import request from '@/utils/request'
import axios from 'axios'

export function getJobQualifications (jobid) {
  return request({
    url: '/Guide',
    method: 'post',
    data: { id: jobid },
  })
}

export function getJobQualificationsWithLink (jobid) {
  return request({
    url: '/Guide?withLink=yes',
    method: 'post',
    data: { id: jobid },
  })
}

export function getApplicationRecord () {
  return request({
    url: '/RoleA/List',
    method: 'post',
  })
}

export function getApplyRetrieve () {
  return request({
    url: '/RoleA/RetrieveApply',
    method: 'post',
  })
}

export function saveSelfEvaluation (data) {
  return request({
    url: '/RoleA/saveCurrent',
    method: 'post',
    data,
  })
}

export function saveCurrentTmp (data) {
  return request({
    url: '/RoleA/saveCurrentTmp',
    method: 'post',
    data,
  })
}

export function saveTarget (tid) {
  return request({
    url: 'RoleA/saveTarget',
    method: 'post',
    data: { target_guide_id: tid },
  })
}

export function submitApply (tid) {
  return request({
    url: 'RoleA/submitApply',
    method: 'post',
    data: { target_guide_id: tid },
  })
}
export function getApplicationDetail (aid) {
  return request({
    url: `RoleA/View?aId=${aid}`,
    method: 'post',
  })
}

// Role B
export function getTeamsApplicationRecord (data) {
  return request({
    url: '/RoleB/list',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
  })
}
export function getTeamsApplicationDetail (aid) {
  return request({
    url: `RoleB/View?aId=${aid}`,
    method: 'post',
  })
}
export function saveApplication (aId, data) {
  return request({
    url: `RoleB/Save?aId=${aId}`,
    method: 'post',
    data,
  })
}
export function approveApplication (aid) {
  return request({
    url: `RoleB/Approve?aId=${aid}`,
    method: 'post',
  })
}
export function disapproveApplication (aid) {
  return request({
    url: `RoleB/Disapprove?aId=${aid}`,
    method: 'post',
  })
}

// ROLE C
export function getGroupApplicationList (data) {
  return request({
    // url: 'http://127.0.0.1:4523/mock2/512816/8889954',
    url: '/RoleC/list',
    params: {
      page: data.pageNum,
      size: data.pageSize,
    },
    method: 'post',
    data: {
      keywords: data.keywords,
      filter: data.filters,
    },
  })
}

export function getGroupApplicationDetail (aid) {
  return request({
    // url: `http://127.0.0.1:4523/mock2/512816/9118319?aId=${aid}`,
    url: `RoleC/View?aId=${aid}`,
    method: 'post',
  })
}

export function reOpenApplication (aid) {
  return request({
    url: `RoleC/ReOpenB?aId=${aid}`,
    method: 'post',
  })
}
export function reSetApplication (aid) {
  return request({
    url: `RoleC/ReOpenA?aId=${aid}`,
    method: 'post',
  })
}

export function hrbpExport (token) {
  return axios({
    url: `/api/RoleC/Export`,
    headers: {
      Authorization: token,
    },
    responseType: 'blob',
    method: 'post',
  })
}

export function hrbpAssessExport (token, apply_ids, is_latest = false) {
  return axios({
    url: `/api/RoleC/ExportAssess`,
    headers: {
      Authorization: token,
    },
    data: {
      apply_ids,
      is_latest,
    },
    responseType: 'blob',
    method: 'post',
  })
}

export function promotionRecordsExport (token, apply_ids) {
  return axios({
    url: `/api/RoleC/ExportPromotionRecords`,
    headers: {
      Authorization: token,
    },
    data: {
      apply_ids,
    },
    responseType: 'blob',
    method: 'post',
  })
}

export function promotionRecordsExportAdmin (token, params = {}) {
  return axios({
    url: `/api/RoleD/ExportPromotionRecords`,
    headers: {
      Authorization: token,
    },
    data: {
      ...params,
    },
    responseType: 'blob',
    method: 'post',
  })
}

export function assessExport (token, apply_ids, is_latest = false) {
  return axios({
    url: `api/RoleB/ExportAssess`,
    headers: {
      Authorization: token,
    },
    data: {
      apply_ids,
      is_latest,
    },
    responseType: 'blob',
    method: 'post',
  })
}
